
import React, { useEffect, useState } from 'react';
import { ApiCall } from "../utility/ApiCalls";
import { Line } from "react-chartjs-2"
import AuditDashboard from '../components/Audit/AuditDashboard';
import Box from "@mui/system/Box";
function Report() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    async function getGraphdata(e) {

        console.log('Inside getGraphdata API call ');

        const ret = await ApiCall(
            {
                  
            },
            "vcare-ui",
            "vcareui_getauditgraphdata "
        );
        const repsonse = ret.body;
        console.log('setting state ===================================================== ');
        console.log(ret.body);

        setData(ret.body);
        setLoading(false);

        return repsonse;
    }
    useEffect(() => {
        getGraphdata();
    }, []);


    if (loading) {
        return (
            <div>
                <Box className="loader-wrapper">
                    <div className="loader"></div>
                </Box>
            </div>
        );
    } else {
        return (
            <AuditDashboard data={data} />
        );
    }


}
export default Report;